import { render, staticRenderFns } from "./DispensaKit.vue?vue&type=template&id=1b219819"
import script from "./DispensaKit.vue?vue&type=script&lang=js"
export * from "./DispensaKit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports